import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { BasePagedDataSource } from '../../../../base/table/paged-table-base.datasource';
import { Item } from '../../models/item';
import { Router } from '@angular/router';
import { ItemService } from '../../services/item.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserService } from '../../../../services/user.service';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ConfirmComponent } from '../../../../dialogs/confirm/confirm.component';
import { map, takeUntil, take } from 'rxjs/operators';
import { ItemType } from '../../models/item-type';
import { UserDto } from '../../../../models/user.model';
import { ItemTypeService } from '../../services/item-type.service';
import { FormGroup, FormControl } from '@angular/forms';
import { ItemFilter } from '../../models/item-filter';
import { MatSelect } from '@angular/material';
import { IAtfterDelete } from '../../../../interfaces/iafter-delete';
import { TranslateService } from '@ngx-translate/core';
import { getEndOfDay } from '../../../shared/date-functions/functions';

@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.css']
})
export class ItemListComponent implements OnInit, AfterViewInit, OnDestroy, IAtfterDelete {

  dataSource = null;
  displayedColumns = ['actions', 'idUser', 'idItemType', 'from', 'till', 'duration', 'lastModification'];
  itemTypes: ItemType[];
  users: UserDto[];
  filters: FormGroup;

  constructor(
    private router: Router,
    private itemService: ItemService,
    private dialog: MatDialog,
    public userService: UserService,
    private itemTypeService: ItemTypeService,
    private translateService: TranslateService,
  ) {
    this.filters = new FormGroup({
      idItemType: new FormControl(),
      idUser: new FormControl({value: null}),
      justMe: new FormControl(false),
      isManul: new FormControl(false),
      from: new FormControl(),
      till: new FormControl()
    });
  }

  public fromCtrl:FormControl = new FormControl();
  public tillCtrl:FormControl = new FormControl();
  public fromValue;
  public tillValue;

  public userFilterCtrl: FormControl = new FormControl(null);
  public filteredUsers: ReplaySubject<UserDto[]> = new ReplaySubject<UserDto[]>(1);
  @ViewChild('userSelect', { static: true }) userSelect: MatSelect;
  protected _onDestroy = new Subject<void>();

  ngAfterViewInit() {

  }
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  ngOnInit() {
    const allLabel = this.translateService.get('dropdown.all').subscribe(all => {
      this.itemTypeService.GetAll().subscribe((data) => {
        const types: ItemType[] = [{
          id: null,
          name: all
        }];
        if (data && data.payload) {
          types.push(...(data.payload));
        }
        this.itemTypes = types;
      });
      this.userService.getMembers().subscribe((data) => {
        if (data) {
          const users: UserDto[] = [{
            id: null,
            fullName: all
          }];
          users.push(...data);
          this.users = users;
          this.setInitialValue();
          this.userFilterCtrl.setValue(null);

          this.filteredUsers.next(this.users.slice());
        }

        this.userFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterUsers();
        });
      });
    });
    setTimeout(() => {
      this.onSubmitFilter();
    }, 0);

    this.filters.valueChanges.subscribe(values => {
      this.onSubmitFilter();
    });        
    this.filters.get('justMe').valueChanges.subscribe(val => {
      if (val) {
        this.filters.get('idUser').disable();
      } else { this.filters.get('idUser').enable(); }
    });
  }
  OnEdit(model: Item) {
    if (this.userService.hasAnyRole(['TimeTrackingAdmin', 'TimeTrackingEditor'])) {
      this.router.navigate(['/timeTracking/items/edit', model.id]);
    }
  }
  private ConrimDelete(id: string): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'dialogs.question',
      message: 'dialogMessages.deleteRecord'
    };

    const dialogRef = this.dialog.open(ConfirmComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(map(
      ret => {
        return ret;
      }
    ));
  }
  onAfterDelete(id?: string) {
    this.onSubmitFilter();
  }
  OnDelete(model: Item) {
    if (model.id) {
      this.ConrimDelete(model.id).subscribe((ret) => {
        if (ret) {
          this.itemService.Delete(model.id).subscribe(() => {
            this.onAfterDelete(model.id);
          });
        }
      });
    }
  }
  OnAdd() {
    this.router.navigate(['/timeTracking/items/add']);
  }
  getUserName(id: string) {
    let ret: string = null;
    if (this.users) {
      const user = this.users.find(u => u.id === id);
      if (user) {
        ret = user.fullName;
      }
    }
    return ret;
  }
  getTypeName(id: string) {
    let ret: string = null;
    if (this.itemTypes) {
      const type = this.itemTypes.find(t => t.id === id);
      if (type) {
        ret = type.name;
      }
    }
    return ret;
  }
  onSelectMine() {
    if (this.userService.current) {
      const idUser = this.userService.current.id;
      const user = this.users.filter(f => f.id === idUser)[0];
      this.filters.controls['idUser'].setValue(user);
      this.onSubmitFilter();
    }
  }
  onSubmitFilter() {
    const user: UserDto = this.filters.get('idUser').value;
    const idType: string = this.filters.get('idItemType').value;
    const from: Date = this.filters.get('from').value;
    let till: Date = this.filters.get('till').value;
    const isManul: Boolean = this.filters.get('isManul').value;

    if(till) {
      till = getEndOfDay(till);
    }

    const filter: any = {
      idItemType: idType,
      idUser: user !== null ? user.id : null,
      from: (from ? from.toISOString() : from),
      till: (till ? till.toISOString() : till),
      isManul: isManul,
      $orderby: 'from desc'
    };
    this.dataSource = new BasePagedDataSource<Item>(this.itemService, filter, 'createdAt desc,from desc');
    this.dataSource.loadData();
  }

  protected setInitialValue() {
    this.filteredUsers
    .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        if (this.userSelect) {
          this.userSelect.compareWith = (a: UserDto, b: UserDto) => a && b && a.id === b.id;
        }        
      });
  }

  protected filterUsers() {
    if (!this.users) {
      return;
    }
    // get the search keyword
    let search = this.userFilterCtrl.value;
    console.log('filterUsers', search);
    if (!search) {
      this.filteredUsers.next(this.users.slice());
      return;
    } else {
      if (typeof search === 'string' || search instanceof String) {
        search = search.toLowerCase();
      }
    }

    // filter the banks
    this.filteredUsers.next(
      this.users.filter(user => user.fullName.toLowerCase().indexOf(search) > -1)
    );
  }
}
